/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconBoxModel2 = createReactComponent("box-model-2", "IconBoxModel2", [
  ["path", { d: "M8 8h8v8h-8z", key: "svg-0" }],
  [
    "path",
    {
      d: "M4 4m0 2a2 2 0 0 1 2 -2h12a2 2 0 0 1 2 2v12a2 2 0 0 1 -2 2h-12a2 2 0 0 1 -2 -2z",
      key: "svg-1"
    }
  ]
]);

export { IconBoxModel2 as default };
//# sourceMappingURL=IconBoxModel2.js.map
